import axios from "axios";
import { plainToInstance } from "class-transformer";
import { EpicSearchResultsWithCursorDto, } from "healthex-common/epic.directory.dtos";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class EpicDirectoryService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async search(query, isSandbox, cursor, filters) {
        const input = {
            search: query,
            cursor,
            isSandbox,
            filters,
        };
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/epic/search"), input, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(EpicSearchResultsWithCursorDto, response.data);
    }
}
